import { useEffect, useState } from "react";
import { webUrlNode } from "../../../../constants/appInfo";

export default function EmailRechargePacks() {

  const [packs, setPacks] = useState([]);

  useEffect(() => {
    load();
  }, []);

  async function load() {
    const r = await fetch(
      `${webUrlNode}/api/credits/packs?channel=email`
    );
    const j = await r.json();
    setPacks(j);
  }

  async function buy(pack) {

    const r = await fetch(
      `${webUrlNode}/api/credits/recharge/create`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ packId: pack.id })
      }
    );

    const data = await r.json();

    // Razorpay popup
    window.openRazorpayCheckout?.(data);
  }

  return (
    <div>

      <h3>Recharge</h3>

      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        {packs.map(p => (
          <div
            key={p.id}
            style={{
              border: "1px solid #ddd",
              borderRadius: 8,
              padding: 12,
              width: 220
            }}
          >
            <div style={{ fontWeight: 600 }}>
              {p.packName}
            </div>

            <div>{p.credits} credits</div>

            <div style={{ marginTop: 6 }}>
              ₹ {(p.amountPaise / 100).toFixed(2)}
            </div>

            <button
              style={{ marginTop: 8 }}
              onClick={() => buy(p)}
            >
              Buy
            </button>
          </div>
        ))}
      </div>

    </div>
  );
}
